module.exports = __webpack_public_path__ + "static/media/jontar.17d7b628.jpeg";